import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const colorMap: Record<string, { bg: string; iconBg: string; text: string }> = {
  primary: {
    bg: 'bg-primary-50 hover:bg-primary-100',
    iconBg: 'bg-primary-100 text-primary-600',
    text: 'text-primary-700',
  },
  accent: {
    bg: 'bg-accent-50 hover:bg-accent-100',
    iconBg: 'bg-accent-100 text-accent-600',
    text: 'text-accent-700',
  },
  secondary: {
    bg: 'bg-secondary-50 hover:bg-secondary-100',
    iconBg: 'bg-secondary-100 text-secondary-600',
    text: 'text-secondary-700',
  },
};

export default function CategoryGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest">
              热门分类
            </p>
            <h2 className="mt-2 text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              全网黑料
              <br />
              实时追踪
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {categories.map((cat) => {
              const colors = colorMap[cat.color] || colorMap.primary;
              return (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`group p-6 md:p-7 rounded-2xl transition-all duration-300 cursor-pointer ${colors.bg}`}
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110 ${colors.iconBg}`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-2">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}